const INITIAL_STATE = {
  seenPopup: false,
  carwashPopupVisible: true,
  carwashPopupExpanded: true,
};

const popupReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_SEEN":
      return { ...state, seenPopup: true };
    case "SET_CARWASH_VISIBLE":
      return { ...state, carwashPopupVisible: action.payload };
    case "SET_CARWASH_EXPANDED":
      return { ...state, carwashPopupExpanded: action.payload };

    default:
      return state;
  }
};

export default popupReducer;
